(function () {
  'use strict';

  angular.module('app').component('debitNoteStatusLabel', debitNoteStatusLabel());

  function debitNoteStatusLabel() {
    return {
      bindings: {
        status: '<',
      },
      controller: DebitNoteStatusLabelComponent,
      controllerAs: 'vm',
      template:
        '<span class="status-label text-{{ vm.statusClass }}">' +
        '<i class="fa fa-circle"></i> {{ vm.statusTitle }}' +
        '</span>',
    };
  }

  DebitNoteStatusLabelComponent.$inject = ['$translate'];

  function DebitNoteStatusLabelComponent($translate) {
    const vm = this;

    vm.$onChanges = function () {
      setStatusLabel();
    };

    function setStatusLabel() {
      let statusLabel = 'default';
      let statusTitle = 'DRAFT';

      switch (vm.status) {
        case 'draft':
          statusLabel = 'default';
          statusTitle = 'DRAFT';
          break;
        case 'processed':
          statusLabel = 'success';
          statusTitle = 'PROCESSED';
          break;
      }

      vm.statusLabel = statusLabel;
      vm.statusTitle = $translate.instant(statusTitle);
    }
  }
})();
